<div *ngFor="let _ of snowflakesRange" [style.visibility]="isWinter() ? 'visible' : 'hidden'" class="snow"></div>
<router-outlet></router-outlet>
<div id="floating">
  <mat-icon class="floating-close-button mat-accent"
            onclick="document.getElementById('floating').style.opacity = '0'; document.getElementById('floating').style.visibility = 'hidden'">
    close
  </mat-icon>
  <img class="wide" id="floating-image" src="" alt="Photo from gallery">
  <p id="floating-alt"></p>
</div>
